import * as Yup from 'yup'

export const suggestionFormValidation = Yup.object().shape({
  suggestion: Yup.lazy(() => Yup.string().required('Обязательное поле')),
})
